import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import _ from 'lodash';
import { Observable } from 'rxjs';

import { TopicvizService } from '../../../services/topicviz/topicviz.service';

@Component({
  selector: 'app-cluster-manager-modal',
  templateUrl: './cluster-manager-modal.component.html',
  styleUrls: ['./cluster-manager-modal.component.scss'],
})
export class ClusterManagerModalComponent implements OnInit {
  clusterConfigurations: any = [];
  public requestInProgress = false;
  public wordLists: any = [];
  public availableDatasets: any = null;
  public mode = 'selectCluster';

  public newClusterConfiguration = {
    cluster_size: 10,
    clustering_algorithm: 'NMF',
    dimensionality_reduction: 'TSNE',
    source_dataset: '<None>',
    target_dataset: '<None>',
    word_list: '<None>',
    additional_dataset: '<None>',
  };
  imageStatus: any;
  selectedWordListFile: any;
  wordListName: any;
  selectedDatasetFile: any;
  datasetName: any;
  additionalDatasets: any;
  routerParams: any;
  currentConfigurationId: any;

  constructor(
    public activeModal: NgbActiveModal,
    private topicVizDataLoader: TopicvizService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  selectMode(mode) {
    if (this.requestInProgress) {
      return;
    }

    if (mode == 'selectCluster' || mode == 'generateCluster') {
      this.loadAvailableDatasets();
      this.loadWordLists();
    }

    this.mode = mode;
  }

  setCurrentConfigurationId(id) {
    this.currentConfigurationId = id;
  }

  resetDatabase() {
    this.topicVizDataLoader.resetAll().subscribe(
      () => {
        alert('All Cluster Data was erased');
        window.location.reload();
      },
      () => {
        alert('Something went wrong');
      },
    );
  }

  isSelectedConfiguration(configuration) {
    return (
      this.currentConfigurationId === configuration['spatial_collection_id']
    );
  }

  openClusterConfiguration(configuration) {
    // Converts the route into a string that can be used
    // with the window.open() function
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/topicviz`], {
        queryParams: {
          spatialCollectionId: configuration['spatial_collection_id'],
        },
      }),
    );

    window.open(url, '_blank');
  }

  handleFileSelectWordList(evt) {
    const files = evt.target.files; // FileList object
    this.selectedWordListFile = files[0];
    const fileName = files[0].name;
    this.wordListName = fileName
      .slice(0, fileName.length - 4)
      .replace(/[^\w\s]/gi, '');
  }

  getSelectedClusteringAlgorithm() {
    return this.newClusterConfiguration['clustering_algorithm'];
  }

  loadWordLists() {
    this.topicVizDataLoader.getWordLists().subscribe(wordLists => {
      this.wordLists = wordLists;
      this.wordLists.push('<None>');
      this.newClusterConfiguration['word_list'] = _.last(this.wordLists);
    });
  }

  loadAvailableDatasets() {
    this.topicVizDataLoader.getAvailableDatasets().subscribe(
      datasets => {
        this.availableDatasets = datasets;
        this.additionalDatasets = _.clone(datasets);
        this.additionalDatasets.push('<None>');
        this.newClusterConfiguration['additional_dataset'] = _.last(
          this.additionalDatasets,
        );
      },
      error => {
        console.error(error);
        alert('an error occured while trying to load available datasets');
      },
    );
  }

  importList(
    listName: string,
    file,
    importRoute: (wordListAsCsv: string, name: string) => Observable<unknown>,
  ) {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = (event: any) => {
      this.requestInProgress = true;
      importRoute(event.target.result, listName).subscribe(
        () => {
          this.loadAvailableDatasets();
          this.loadWordLists();
          this.requestInProgress = false;
        },
        response => {
          alert(response.error['message']);
          this.requestInProgress = false;
        },
      );
    };
  }

  importWordList() {
    if (
      this.requestInProgress ||
      !this.selectedWordListFile ||
      !this.wordListName
    ) {
      return;
    }
    this.importList(
      this.wordListName,
      this.selectedWordListFile,
      (wordListAsCsv: string, name: string) =>
        this.topicVizDataLoader.importWordList(wordListAsCsv, name),
    );
  }

  loadClusterConfigurations() {
    this.topicVizDataLoader
      .getClusterConfigurations()
      .subscribe(configurations => {
        this.clusterConfigurations = configurations;
      });
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  ngOnInit() {
    this.loadAvailableDatasets();
    this.loadWordLists();
    this.loadClusterConfigurations();
    this.loadImageInformation();
    this.route.queryParams.subscribe(params => {
      this.routerParams = params;
    });
  }

  loadImageInformation() {
    this.topicVizDataLoader.getImageStatus().subscribe(data => {
      this.imageStatus = data;
    });
  }

  configurationToParams(configuration: object) {
    let wordList = configuration['word_list'] || '<None>';
    let additionalDataset = configuration['additional_dataset'] || '<None>';
    if (wordList == '<None>') {
      wordList = null;
    }
    if (additionalDataset == '<None>') {
      additionalDataset = null;
    }

    return {
      clusteringAlgorithm: configuration['clustering_algorithm'].toLowerCase(),
      clusterSize: configuration['cluster_size'],
      sourceDatasetName: configuration['source_dataset'].toLowerCase(),
      targetDatasetName: configuration['target_dataset'].toLowerCase(),
      reductionAlgorithm:
        configuration['dimensionality_reduction'].toLowerCase(),
      wordList: wordList,
      additionalDataset: additionalDataset,
    };
  }

  computeClusterConfiguration(configuration: object) {
    this.setLoading(true);
    this.topicVizDataLoader
      .computeCluster(this.configurationToParams(configuration))
      .subscribe(
        newConfiguration => {
          this.setLoading(false);
          this.loadClusterConfigurations();
          this.openClusterConfiguration(newConfiguration); //open computed cluster in new tab
        },
        error => {
          if (error['message']) {
            console.error(error['message']);
          }
          alert(`Cluster Computation failed`);
          this.setLoading(false);
        },
      );
  }

  createNewCluster() {
    this.computeClusterConfiguration(this.newClusterConfiguration);
  }

  markDefault(configuration: object) {
    this.setLoading(true);
    this.topicVizDataLoader
      .setDefaultCluster(this.configurationToParams(configuration))
      .subscribe(
        () => {
          this.setLoading(false);
          this.loadClusterConfigurations();
        },
        error => {
          alert('Could not assign default cluster');
          console.error(error);
          this.setLoading(false);
        },
      );
  }

  setLoading(flag) {
    this.requestInProgress = flag;
  }

  deleteCluster(configuration: object) {
    this.setLoading(true);
    this.topicVizDataLoader
      .deleteCluster({
        spatialCollectionId: configuration['spatial_collection_id'],
      })
      .subscribe(
        () => {
          this.setLoading(false);
          this.loadClusterConfigurations();
        },
        error => {
          alert('Cluster could not be deleted');
          console.error(error);
          this.setLoading(false);
        },
      );
  }
}
